import $ from "jquery";

const breadcrumbs = () => {
  const init = () => {
    disableInformatie();
  };

  const el = {
    breadcrumbs: ".woocommerce-breadcrumb .breadcrumb-item>a:contains(Informatie)",
  }

  const disableInformatie = () => {
    // $(function () {
    // eslint-disable-next-line no-console
    $('awdawdaaswadasaaasas')
    $(el.breadcrumbs)
    // });
  };

  init();
};

try {
  breadcrumbs();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
